import type { LastFetchState } from "@Modules/urls/Api/UrlsApi";

export function buildFilterQuery(lastFetch: LastFetchState): Record<string, string> {
    const query: Record<string, string> = {};

    if (lastFetch.filter?.type && lastFetch.filter.type !== "available") {
        query.list = lastFetch.filter.type;
    }
    if (lastFetch.search?.searchType && lastFetch.search.searchType !== "alias") {
        query.searchType = lastFetch.search.searchType;
    }
    if (lastFetch.search?.searchValue) {
        query.search = lastFetch.search.searchValue;
        if (lastFetch.search.searchType === "tag") {
            query.tag = lastFetch.search.searchValue;
        }
    }

    return query;
}
